import React from 'react';
import { Card } from '../../components/card/Card.view';
import Media from '../../components/media';

export const CallToActionCard: React.FC<{
  name: React.ReactNode;
  tagline?: React.ReactNode;
  description: React.ReactNode;
  actions?: React.ReactNode[];
  asideActions?: React.ReactNode[];
}> = ({ name, tagline, description, actions, asideActions, ...props }) => {
  const heading = [
    <h3 key="name" className="heading-section">
      {name}
    </h3>,
    <small key="tag">{tagline}</small>,
  ];

  return (
    <Card
      text={description}
      header={<Media>{heading}</Media>}
      actions={actions}
      asideActions={asideActions}
      type="notification"
      {...props}
    />
  );
};
